import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterUnit extends Component {
  onChange = values => {
    const { activeUnits, setMyJobsDataViewerFilter } = this.props
    const locuses = ArrayHelper.getArrData(values, [])

    if (!isEqual(locuses, activeUnits.toArray())) {
      setMyJobsDataViewerFilter({ locuses })
    }
  }

  render() {
    const { activeUnits, unitList } = this.props
    const values = ArrayHelper.getValues(activeUnits, unitList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: [-1],
        }}
        variant="outlined"
        name="site"
        label={formatMessage('units')}
        list={unitList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'containerName',
        }}
      />
    )
  }
}

FilterUnit.defaultProps = {
  activeUnits: List([]),
  unitList: List([]),
}

FilterUnit.propTypes = {
  activeUnits: PropTypes.instanceOf(List),
  unitList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeUnits: store.getIn(['profile', 'jobsDataViewerFilters', 'locuses']),
    unitList: store.getIn(['myJobsDataViewer', 'filters', 'units']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterUnit)
